import { render, staticRenderFns } from "./DealSummary.vue?vue&type=template&id=25f8d514"
import script from "./DealSummary.vue?vue&type=script&lang=js"
export * from "./DealSummary.vue?vue&type=script&lang=js"
import style0 from "./DealSummary.vue?vue&type=style&index=0&id=25f8d514&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports